import React from "react"

import H2 from "../atoms/H2"
import H3 from "../atoms/H3"

import styles from "./Header.module.css"

const Header = props => (
  <header className={styles.header}>
    <H2>{props.title}</H2>
    <H3>{props.subtitle}</H3>
  </header>
)

export default Header
